// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"IJ-z","carouselContainer":"JJ-z"};